import dayjs from 'dayjs';

export const generateDatesDiff = (date: string): number => {
  const hoursDiff = dayjs(date).diff(dayjs(new Date()), 'hours');
  return hoursDiff > 0 ? dayjs(date).diff(dayjs(new Date()), 'day') + 1 : 0;
};
